import type { RateLineImportRowStatus } from '../../../rate-cards.api';

export const ROW_STATUS_LABELS: Record<RateLineImportRowStatus, string> = {
  new: 'New',
  changed: 'Changed',
  unchanged: 'Unchanged',
  invalid: 'Invalid',
  historical: 'Historical (reference only)',
};

export const ROW_STATUS_COLORS: Record<RateLineImportRowStatus, string> = {
  new: 'success',
  changed: 'processing',
  unchanged: 'default',
  invalid: 'error',
  historical: 'default',
};

/** Only these rows open a draft proposal on commit — the rest are shown but create nothing. */
export function isActionableRow(status: RateLineImportRowStatus): boolean {
  return status === 'new' || status === 'changed';
}
